import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ReqUpdateUserInfo } from '@/apis/auth/types';
import { useUserInfo } from '@/hooks/index';
import { RootState } from '@/stores/index';
import PATHS from '@/types/navigationPaths';
import contents from '@/assets/config/appInfo';
import { useTranslation } from 'react-i18next';
import ProfileSetup from '@/organisms/ProfileSetup';
import EnrollmentTemplate from '@/templates/EnrollmentTemplate';

const ProfileSetupGbcAuthImportScreen = () => {
  const { t } = useTranslation('common');

  const {
    userInfo: {
      data: { userInfo },
    },
    enrollment: { enrollmentInfo },
  } = useSelector((state: RootState) => state);

  // Profile setup
  document.title = `${t('screens.enrollment.profileSetupGbcAuthImportScreen.title')} - ${contents.name}`;

  const [disableNext, setDisableNext] = useState(true);

  const navigate = useNavigate();
  const { fetchUpdateUserInfo } = useUserInfo();

  const validationCheck = () => {
    const disabled = enrollmentInfo.firstName.length < 2 || enrollmentInfo.lastName.length < 2;
    setDisableNext(disabled);
  };

  const handleNext = () => {
    const payload: ReqUpdateUserInfo = {
      firstName: enrollmentInfo.firstName,
      lastName: enrollmentInfo.lastName,
    };

    fetchUpdateUserInfo(payload, () => {
      if (window.ReactNativeWebView) {
        const data = JSON.stringify({ loading: true });
        window.ReactNativeWebView.postMessage(data);
      }
    });

    navigate(PATHS.SCREEN_ENROLLMENT_CONFIRMATION_GBC_AUTH_IMPORT.pathname);
  };

  useEffect(() => {
    if (userInfo.id && !userInfo.isAuthenticated) {
      const payload: ReqUpdateUserInfo = {
        isAuthenticated: true,
      };

      fetchUpdateUserInfo(payload);
    }
  }, []);

  useEffect(() => {
    validationCheck();
  }, [enrollmentInfo]);

  return (
    <EnrollmentTemplate
      disabled={disableNext}
      underline
      navigationTitle={t('screens.enrollment.profileSetupScreen.title')}
      navigationPath={PATHS.SCREEN_ENROLLMENT_PROFILE_SETUP_GBC_AUTH_IMPORT.pathname}
      onNext={handleNext}
      textNext={t('common.generalButtons.next')}
      previousNavigationPath={undefined}
      onBack={() => {
        navigate(PATHS.SCREEN_ROOT.pathname, { replace: true });
      }}
    >
      <ProfileSetup />
    </EnrollmentTemplate>
  );
};

export default ProfileSetupGbcAuthImportScreen;
